import { render } from "./ConfirmPassword.vue?vue&type=template&id=2601507a"
import script from "./ConfirmPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmPassword.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniokatarov/PhpstormProjects/WEBIS WHS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__